(function(){
  document.addEventListener('DOMContentLoaded', function() {
      console.log(1243);
     let themes = {};
    themes = {
      recentlyViewedIds: [],
      config: {
        hasLocalStorage: true,
      }
    }
    function loadRecentlyProducts(theme) {
      console.log('jsfile');
      var recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds && typeof(recentIds) !== undefined) {
        theme.recentlyViewedIds = JSON.parse(recentIds);
      }

      // Stop if no data
      let container = document.querySelector('[data-section-type="recently-viewed"]');
      if (container && !theme.recentlyViewedIds.length) {
        container.classList.add('hide');
        return;
      }

      this.outputContainer = document.getElementById('RecentlyViewed');

      if ( !this.outputContainer ) return false;
      // var currentId = this.container.getAttribute('data-product-id');

      var url = '/search?view=recently-viewed&type=product&q=';
      var products = '';
      var i = 0;
      let maxProducts = 5;
      
      theme.recentlyViewedIds.forEach(function(val) {
        // Skip current product
        // if (val === currentId) {
        //   return;
        // }

        // Stop at max
        if (i >= maxProducts) {
          return;
        }

        products += 'id:' + val + ' OR ';
        i++;
      });

      url = url + encodeURIComponent(products);

      fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var count = doc.querySelectorAll('.product-grid').length;
        // let containerOut = document.getElementById('RecentlyViewed');
        if (count > 0) {
          var results = doc.querySelector('.product-grid');
          this.outputContainer.append(results);
          sliderInit('recently_swiper');
          container.classList.remove('hide');
        } else {
          this.outputContainer.classList.add('hide');
        }

      });
    }
    loadRecentlyProducts(themes);
   
    function setRecentlyProducts(theme) {
      
      var productCurrent = document.querySelector('.template-product [name="product-id"]');
      theme.recentlyViewedIds.forEach(function(val) {
        if (val === null ) {
          theme.recentlyViewedIds = [];
        }
      });
      if ( !productCurrent ) return false;
      let id = productCurrent.value;
  
      if (!id) return;
  
      // Remove current product if already in recently viewed array
      var i = theme.recentlyViewedIds.indexOf(id);
      if (i > -1) {
        theme.recentlyViewedIds.splice(i, 1);
      }
  
      theme.recentlyViewedIds.unshift(id);
      if ( theme.recentlyViewedIds.length > 5 ) {
        theme.recentlyViewedIds.length = 5;
      }
  
      // theme.recentlyViewedIds = theme.recentlyViewedIds.slice(1,6);
  
      if (theme.config.hasLocalStorage) {
        window.localStorage.setItem('recently-viewed', JSON.stringify(theme.recentlyViewedIds));
      }
    }
    setRecentlyProducts(themes);
  
    function sliderInit(selector) {
      const sliderSettings = {
        slidesPerView: 4,
        spaceBetween: 21,
        navigation: {
          nextEl: `.${selector}.swiper .swiper-button-next`,
          prevEl: `.${selector}.swiper .swiper-button-prev`,
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 21,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
      };
    
      let sliderElement = document.querySelectorAll(`[data-section-type="recently-viewed"] .${selector}.swiper`);
      sliderElement.forEach(elem => {
        if ( ! elem ) return false;
        new Swiper(elem, sliderSettings);
      });
    }
  }, false);
})();